const globalNavZIndex = 2_000;

export const zIndex = {
  selectDropdown: 4,
  collectionTileLightShadow: 5,
  collectionTileDarkShadow: 10,
  collectionTile: 15,
  mediaPlayerButtonPopover: 100,
  carouselArrow: 900,
  expandButton: 1_000,
  progressBarText: 1_000,
  tileTopElement: 1_500, // originally 9_999
  globalNav_root: globalNavZIndex,
  globalNav_navbar: globalNavZIndex,
  globalNav_subnav: globalNavZIndex,
  globalNav_overlay: globalNavZIndex + 1,
  globalNav_navMenu: globalNavZIndex + 2,
  globalNav_myForumMenu: globalNavZIndex + 2,
  globalNav_mfeMessaging: globalNavZIndex + 2,
  globalNav_mfeNotifications: globalNavZIndex + 2,
  mobileAppBanner: 3_000,
  overlay: 3_500, // originally 1_000
  audioPlayer: 4_000, //originally 1_000
  mediaPlayer: 4_000, // originally 1_000
  frame: 4_500,
  modal: 5_000, // originally 1_001
  coachmarkOverlay: 9_997,
  coachmarkInactive: 9_998,
  coachmarkActive: 9_999,
  coachmarkOverlayWrapper: 9_999,
} as const satisfies Record<string, number>;
